var _style, _path, _defs, _defs2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0052B4;}\n\t.st1{clip-path:url(#SVGID_00000171680021813012396510000017963402011222858649_);}\n\t.st2{clip-path:url(#SVGID_00000038371165423593906300000010201231672037718168_);fill:#F0F0F0;}\n\t.st3{clip-path:url(#SVGID_00000038371165423593906300000010201231672037718168_);}\n\t.st4{fill:#D80027;}\n\t.st5{fill:#338AF3;}\n\t.st6{fill:#FFDA44;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.4,87.1L448.4,87.1C444.8,83,441,78.9,437,75c-3.9-4-8-7.8-12.1-11.4l0,0C324.3-24.8,171-21,75,75 s-99.8,249.3-11.4,349.8C67.2,429,71,433.1,75,437c4,4,8,7.8,12.2,11.4C187.7,536.8,341,533,437,437S536.8,187.7,448.4,87.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M448.4,87.1L448.4,87.1C444.8,83,441,78.9,437,75c-3.9-4-8-7.8-12.1-11.4l0,0C324.3-24.8,171-21,75,75 s-99.8,249.3-11.4,349.8C67.2,429,71,433.1,75,437c4,4,8,7.8,12.2,11.4C187.7,536.8,341,533,437,437S536.8,187.7,448.4,87.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077290315347762172620000005627181329736519813_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000077290315347762172620000005627181329736519813_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000052100006042212888230000000291075591065450375_",
    width: 256,
    height: 256
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075841823609531487250000015645103823314260875_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052100006042212888230000000291075591065450375_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000075841823609531487250000015645103823314260875_)",
      fill: "#F0F0F0"
    },
    cx: 66.8,
    cy: 66.8,
    r: 256
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.3,
    y: 208.8,
    style: {
      clipPath: "url(#SVGID_00000075841823609531487250000015645103823314260875_)",
      fill: "#F0F0F0"
    },
    width: 16.7,
    height: 47.2
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000075841823609531487250000015645103823314260875_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-136.3-89.1c-20.1,26.2-35.3,56.3-44.1,89.1h133.2L-136.3-89.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314,0c-8.8-32.8-24-62.9-44.1-89.1L180.8,0H314z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-180.4,133.6c8.8,32.8,24,62.9,44.1,89.1l89.1-89.1H-180.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.7-136.3c-26.2-20.1-56.3-35.3-89.1-44.1v133.2L222.7-136.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-89.1,269.9C-62.9,290-32.8,305.2,0,314V180.8L-89.1,269.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0-180.4c-32.8,8.8-62.9,24-89.1,44.1L0-47.2V-180.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.6,314c32.8-8.8,62.9-24,89.1-44.1l-89.1-89.1V314z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.8,133.6l89.1,89.1c20.1-26.2,35.3-56.3,44.1-89.1H180.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000075841823609531487250000015645103823314260875_)"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M320.6,33.4H100.2l0,0V-187c-10.9-1.5-22.1-2.2-33.4-2.2c-11.3,0-22.5,0.7-33.4,2.2V33.4l0,0H-187 c-1.5,10.9-2.2,22.1-2.2,33.4c0,11.3,0.7,22.5,2.2,33.4H33.4l0,0v220.4c10.9,1.4,22.1,2.2,33.4,2.2c11.3,0,22.5-0.7,33.4-2.2 V100.2l0,0h220.4c1.4-10.9,2.2-22.1,2.2-33.4C322.8,55.5,322.1,44.3,320.6,33.4L320.6,33.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M133.6,133.6L256,256c5.3-5.3,2.1-18.9,6.8-24.6L165,133.6H133.6L133.6,133.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M0,133.6L0,133.6l-114.2,114.2c5.3,5.3,10.7,10.3,16.4,15L0,165L0,133.6L0,133.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M0,0L0,0l-114.2-114.2c-5.3,5.3-10.3,10.7-15,16.4L-31.4,0L0,0L0,0z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M133.6,0l114.2-114.2c-5.3-5.3-10.7-10.3-16.4-15l-97.8,97.8V0z"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path17",
    className: "st5",
    d: "M444.7,224.5c-0.1,49.8-8.1,103.4-73,128.9c-64.9-25.5-72.8-79.1-73-128.9H444.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    className: "st6",
    d: "M444.7,224.5c0.1-18.7-1-36.9-0.5-52.9c-24.3-10.8-56.2-13-72.4-13c-16.3,0-48.2,2.2-72.4,13 c0.5,15.9-0.6,34.1-0.5,52.9H444.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.7,
    cy: 191.5,
    r: 16.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSh);
export default __webpack_public_path__ + "static/media/sh.c494d035abbd3703ce4006d10168cac6.svg";
export { ForwardRef as ReactComponent };